import { useDisclosure } from "@mantine/hooks"
import { PlusIcon, TrayIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { DisabledReason, HelpButtonGroup } from "@dehub/theme"
import { DeliveryActionButton } from "../../components/delivery/action-controls"
import { InboundOrders } from "../../components/inbound-orders"
import { useInboundActions } from "../../components/inbound-orders/inbound-actions"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"

const useBreadcrumb = (t: (key: string) => string) => [{ to: "/", label: t("common:breadcrumb.home") }, { label: t("inbound:breadcrumb.inbound") }]

export function InboundPage() {
  const { t } = useTranslation(["inbound", "common"])
  // The backend list/get/exceptions routes all need IBN_CREATE (contract §1), so the page gate uses it too (O125).
  const IBN_CREATE = usePermission("IBN_CREATE")
  const { stateOf } = useInboundActions()
  const [createOpened, { open: openCreate, close: closeCreate }] = useDisclosure(false)
  const breadcrumbs = useBreadcrumb(t)

  return (
    <PageLayout
      icon={<TrayIcon size={22} />}
      title={t("inbound:list.title")}
      subTitle={t("inbound:list.pageSubtitle")}
      breadcrumb={breadcrumbs}
      extra={
        IBN_CREATE.hasAccess
          ? [
              // @dehub/help: attached «?» (R2) + reason popover without the permission (R4).
              <DisabledReason key="new" helpKey="order.inbound.reason.permission" reason="new" when={!stateOf("create", {}).allowed} position="bottom-end">
                <HelpButtonGroup helpKey="order.inbound.action.new">
                  <DeliveryActionButton data-help-id="inbound-new" state={stateOf("create", {})} leftSection={<PlusIcon size={16} />} onClick={openCreate}>
                    {t("inbound:list.new")}
                  </DeliveryActionButton>
                </HelpButtonGroup>
              </DisabledReason>,
            ]
          : undefined
      }
    >
      {IBN_CREATE.hasAccess ? <InboundOrders createOpened={createOpened} onCreateClose={closeCreate} onCreateOpen={openCreate} /> : IBN_CREATE.accessDenied()}
    </PageLayout>
  )
}
